/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown>, error: NonNullable<unknown> }} Explorer_Kanban_Open_Failed_ToastInputs */

const en_explorer_kanban_open_failed_toast = /** @type {(inputs: Explorer_Kanban_Open_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to open ${i?.type}: ${i?.error}`)
};

const fr_explorer_kanban_open_failed_toast = /** @type {(inputs: Explorer_Kanban_Open_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec d'ouverture de ${i?.type} : ${i?.error}`)
};

const de_explorer_kanban_open_failed_toast = /** @type {(inputs: Explorer_Kanban_Open_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Öffnen von ${i?.type}: ${i?.error}`)
};

const it_explorer_kanban_open_failed_toast = /** @type {(inputs: Explorer_Kanban_Open_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile aprire ${i?.type}: ${i?.error}`)
};

const ru_explorer_kanban_open_failed_toast = /** @type {(inputs: Explorer_Kanban_Open_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось открыть ${i?.type}: ${i?.error}`)
};

const es_explorer_kanban_open_failed_toast = /** @type {(inputs: Explorer_Kanban_Open_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo abrir ${i?.type}: ${i?.error}`)
};

const zh_cn2_explorer_kanban_open_failed_toast = /** @type {(inputs: Explorer_Kanban_Open_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`打开 ${i?.type} 失败：${i?.error}`)
};

const ja_explorer_kanban_open_failed_toast = /** @type {(inputs: Explorer_Kanban_Open_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.type} を開けませんでした: ${i?.error}`)
};

const hi_explorer_kanban_open_failed_toast = /** @type {(inputs: Explorer_Kanban_Open_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.type} खोलने में विफल: ${i?.error}`)
};

const pt_pt2_explorer_kanban_open_failed_toast = /** @type {(inputs: Explorer_Kanban_Open_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao abrir ${i?.type}: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to open {type}: {error}" |
*
* @param {Explorer_Kanban_Open_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_kanban_open_failed_toast = /** @type {((inputs: Explorer_Kanban_Open_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Kanban_Open_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_kanban_open_failed_toast(inputs)
	if (locale === "de") return de_explorer_kanban_open_failed_toast(inputs)
	if (locale === "it") return it_explorer_kanban_open_failed_toast(inputs)
	if (locale === "ru") return ru_explorer_kanban_open_failed_toast(inputs)
	if (locale === "es") return es_explorer_kanban_open_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_kanban_open_failed_toast(inputs)
	if (locale === "ja") return ja_explorer_kanban_open_failed_toast(inputs)
	if (locale === "hi") return hi_explorer_kanban_open_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_kanban_open_failed_toast(inputs)
	return en_explorer_kanban_open_failed_toast(inputs)
});